import { Injectable } from '@angular/core';
import { EmploymentStatus } from '../../../employment-statuses/employment-status';
import { ReduxApiActions } from '../../shared/redux-api.actions';

@Injectable()
export class EmploymentStatusActions extends ReduxApiActions<EmploymentStatus> {
  public endpoint: string = 'employment-statuses';
  public reduxActionValue: string = 'EMPLOYMENT_STATUSES';
}
